<template>
  <v-slide-y-transition mode="out-in">
    <v-container class=" pa-0 pb-4 fluid">      
      <v-layout column>
        <v-flex sm12>
          <form-eks v-if="showFormEks"></form-eks>
          <form-leg v-if="showFormLeg"></form-leg>
          <form-dpd v-if="showFormDpd"></form-dpd>              
        </v-flex>
      </v-layout>  
    </v-container>
  </v-slide-y-transition>
</template>
<script>
import FormEks from './form-eks';
import FormLeg from './form-leg';
import FormDpd from './form-dpd';

export default {
  components: {
    FormEks,
    FormLeg,
    FormDpd
  },
  data () {
    return {
      //chat: null,
      //selectedTab: null,
    };
  },
  computed: {
    showFormEks() {
      return this.$route.query.mode == 1;
    },
    showFormLeg() {
      return this.$route.query.mode == 2;
    },
    showFormDpd() {
      return this.$route.query.mode == 3;
    },            
  },
};
</script>

